import { Box, Button, Menu, MenuItem, Typography, useTheme, useMediaQuery } from "@mui/material";
import { Stack } from "@mui/system";
import React, { useEffect, useState } from "react";
import MenuIcon from '@mui/icons-material/Menu';
// import CircleIcon from '@mui/icons-material/Circle';
import Tabs from "./tabs/tabs";
import { useLocation, useNavigate } from "react-router-dom";
import { checkLogin, loggout } from "../utils/functions";
import { useDispatch, useSelector } from "react-redux";
import authServices from "../services/authServices";
import { saveUser } from "../redux/reducers/userSlice";
import RealxSelect from './modals/realxSelect';
import { useSnackbar } from "notistack";
import logsService from "../services/logServices";
import { event } from "react-ga";
import { InvestorActivityEventType } from "../utils/eventTypes";
import { isAppInstalled } from "./pwa/installController";

export default function Header() {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector(state => state.user.data);
    const [activeTab, setActiveTab] = useState(0);
    const [anchorEl, setAnchorEl] = useState(null);
    const [width, setWidth] = useState(window.innerWidth);
    const { pathname } = useLocation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const isSelectUser = user?.membershiptype === "SELECT" ? true : false;
    const logo = isSelectUser ? "/assets/images/realx_select.png" : '/assets/images/logo.png';
    const { enqueueSnackbar } = useSnackbar();
    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };


    const tabs = [
        {
            name: "Dashboard",
            link: "/dashboard"
        },
        // {
        //     name:"Marketplace",
        //     link:"/marketplace",
        // },
        {
            name: "Portfolio",
            link: "/portfolio"
        },
        {
            name: "Wallet",
            link: "/wallet"
        },
        {
            name: "Transactions",
            link: "/transactions"
        },
        //  {
        //     name: "Transfer",
        //     link: "/transfer"
        // },
    ]

    const openMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    useEffect(() => {
        console.log(pathname, "----->Current route");
        console.log(tabs.findIndex((e) => pathname.includes(e.link)), "----->Current tab");
        const index = tabs.findIndex((e) => pathname.includes(e.link));
        if (index >= 0) {
            setActiveTab(index);
        }
        if (!checkLogin()) {
            navigate("/")
        }
        // eslint-disable-next-line
    }, [pathname]);

    useEffect(() => {
        window.addEventListener("resize", changeWidth);
        getUserData();
        return () => window.removeEventListener("resize", changeWidth);
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        const button = document.getElementById('auto-ripple-button');

        const createRipple = (event) => {
            const ripple = document.createElement('span');
            ripple.classList.add('ripple');
            ripple.style.top = `${event.clientY - button.getBoundingClientRect().top}px`;
            ripple.style.left = `${event.clientX - button.getBoundingClientRect().left}px`;
            button.appendChild(ripple);

            setTimeout(() => {
                ripple.remove();
            }, 800); // Adjust the duration of the ripple effect as needed
        };

        button.addEventListener('click', createRipple);

        return () => {
            button.removeEventListener('click', createRipple);
        };
    }, []);

    const changeWidth = () => {
        setWidth(window.innerWidth);
    }

    const handleTabClick = (index) => {
        setActiveTab(index);
        if (tabs[index]) {
            navigate(tabs[index].link, { replace: true });
        }
        if(tabs[index].name === "Portfolio"){
            logsService.addLog({
                userId: user?._id,
                event: InvestorActivityEventType.PORTFOLIO_VIEWED
            })
        }
        if(tabs[index].name === "Transactions"){
            logsService.addLog({
                userId: user?._id,
                event: InvestorActivityEventType.TRANSACTION_PAGE_VIEWED
            })
        }
        if(tabs[index].name === "Wallet"){
            logsService.addLog({
                userId: user?._id,
                event: InvestorActivityEventType.WALLET_PAGE_VIEWED
            })
        }
    }

    const getUserData = async () => {
        try {
            if (user && user?._id) {
                const res = await authServices.getUser(user?._id);
                if (res && res.success && res.data && res.data.length > 0) {
                    console.log(res);
                    dispatch(saveUser(res.data[0]));
                }
                else {
                    enqueueSnackbar(res?.data?.message || "Something went wrong", { variant: "error" });
                }
            }
        } catch(error){
            enqueueSnackbar("Something went wrong", { variant: "error" });
        }
    }


    return (
        <Box
            sx={{
                // height:"100px",
                width: "100%",
                position: "absolute",
                top: 0,
                bgcolor: "#FFF",
                px: { xs: "32px", md: "100px" },
                py: "20px",
            }}
        >
            <RealxSelect
                open={isModalOpen}
                handleClose={closeModal}
                ownerType="Owner Type Value"
                propertyData="Property Data Value"
                handleSubmit={(amount) => {
                    // Handle the amount submitted from the modal
                    console.log(`Amount submitted: ${amount}`);
                    closeModal();
                }}
            />

            <ProfileMenu anchorEl={anchorEl} setAnchorEl={setAnchorEl} user={user} />
            <Stack direction={"row"}>
                <Stack direction={"row"} spacing={"90px"} flex={1} alignItems={"center"}>
                    <Box onClick={() => navigate("/dashboard")} sx={{ height: { xs: 24, md: 54 }, cursor: "pointer" }} component={"img"} src={logo}></Box>
                    {
                        width > 900 ?
                            <Tabs activeTab={activeTab} tabs={tabs} onClick={handleTabClick} />
                            : ""
                    }
                </Stack>
                <Stack direction={"row"} spacing={5} alignItems={"center"}>
                    <div>
                        <Button
                            spacing={3}
                            id="auto-ripple-button"
                            onClick={() => openModal(true)}
                            sx={{
                                mb: { md: 0, xs: 3 }, marginRight: '20px', position: 'relative',
                                display: isSelectUser ? 'none' : 'none', // TODO removed none when select feature is required
                                overflow: 'hidden'
                            }}
                            variant="contained"
                        >Join Select</Button>
                    </div>
                </Stack>

                <Stack direction={"row"} spacing={5} alignItems={"center"}>
                    <Stack direction={"row"} spacing={3} alignItems={"center"}>
                        <Stack sx={{ maxWidth: "130px" }} direction={"row"} alignItems={"center"} spacing={3}>
                            <Box sx={{ position: "relative", flexShrink: 0 }}>
                                <Box
                                    sx={{
                                        width: 44,
                                        height: 44,
                                        borderRadius: "50%",
                                        bgcolor: "background.paper",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontWeight: 700,
                                        fontSize: 20,
                                        color: "#000000",
                                        textTransform: "uppercase",
                                        userSelect: "none",
                                        border: user?.founderCircle?.slotNumber
                                            ? "2px solid #C9A227"
                                            : "2px solid #000000",
                                        boxShadow: user?.founderCircle?.slotNumber
                                            ? "0 0 0 2px rgba(201, 162, 39, 0.25)"
                                            : "none",
                                    }}
                                >
                                    {user?.username
                                        ? user.username
                                            .split(' ')
                                            .map(word => word[0])
                                            .join('')
                                            .slice(0, 2)
                                        : "U"}
                                </Box>
                                {user?.founderCircle?.slotNumber && (
                                    <Box
                                        title={`Founder Circle #${user.founderCircle.slotNumber}`}
                                        sx={{
                                            position: "absolute",
                                            left: "50%",
                                            bottom: -6,
                                            transform: "translateX(-50%)",
                                            px: 0.6,
                                            py: 0.15,
                                            borderRadius: 999,
                                            bgcolor: "#C9A227",
                                            color: "#fff",
                                            fontSize: "8px",
                                            fontWeight: 700,
                                            letterSpacing: "0.04em",
                                            lineHeight: 1.2,
                                            whiteSpace: "nowrap",
                                            boxShadow: "0 1px 3px rgba(0,0,0,0.18)",
                                        }}
                                    >
                                        F.C.# {user.founderCircle.slotNumber}
                                    </Box>
                                )}
                            </Box>
                            {!isSmallScreen && (
                                <Stack spacing={0} sx={{ minWidth: 0 }}>
                                    <Typography
                                        variant='body2'
                                        sx={{
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            color: "text.primary",
                                        }}
                                    >
                                        {user?.username || "User"}
                                    </Typography>
                                </Stack>
                            )}
                       
                        </Stack>
                    </Stack>
                    {/* <Box sx={{width:"1px",height:"60px",bgcolor:"#A4A4A4",mt:"-2px !important"}}></Box> */}
                    {!isSmallScreen && <MenuIcon sx={{ cursor: "pointer" }} onClick={openMenu} fontSize="medium" />}
                </Stack>
            </Stack>
        </Box>
    )
}

const ProfileMenu = ({ anchorEl, setAnchorEl, user }) => {

    const open = Boolean(anchorEl);
    const navigate = useNavigate();

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClick = (link) => {
        navigate(link);
        setAnchorEl(null);
    }

    const handleLoggout = () => {
        navigate("/");
        loggout();
        setAnchorEl(null);
    }


    const handleProfileClick = () => {
        navigate("/dashboard/profile")
        setAnchorEl(null);
        logsService.addLog({
            userId: user?._id,
            event: InvestorActivityEventType.PROFILE_VIEWED
        })
    }
    return (
        <Menu
            PaperProps={{
                sx: {
                    minWidth: "fit-content !important"
                }
            }}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            open={open}
            onClose={handleClose}
            MenuListProps={{
                'aria-labelledby': 'basic-button',
            }}
        >
            {["KYC_APPROVED", "APPROVED"].includes(user?.status) && <MenuItem onClick={handleProfileClick}>
                <Stack direction={"row"} spacing={1.5}>
                    {/* <CircleIcon sx={{width:16,height:16}} /> */}
                    <Typography variant="body2">My Profile</Typography>
                </Stack>
            </MenuItem>}
            <MenuItem onClick={handleLoggout}>
                <Stack direction={"row"} spacing={1.5}>
                    {/* <CircleIcon sx={{width:16,height:16}} /> */}
                    <Typography variant="body2">Logout</Typography>
                </Stack>
            </MenuItem>

        </Menu>
    )
}